import FormInput, { InputProps } from '@/components/Form/FormInput';
import { IconButton } from '@mui/material';
import { PwdHiddenOutlined, PwdShowOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

// 密码输入组件的属性
type PasswordInputProps = Omit<InputProps, 'formatInput' | 'rules'>;

const PasswordInput: React.FC<PasswordInputProps> = ({
  name,
  control,
  placeholder,
  label,
  slotProps,
  layout = 'inline',
  clearable = true,
  ...restProps
}) => {
  const t = useTranslations('components.form.password');
  const [showPassword, setShowPassword] = useState(false);

  // 切换密码可见性
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // 自定义格式化函数，可用于处理密码特殊字符过滤等
  const formatPassword = (password: string): string => {
    // 这里可以添加密码格式化逻辑，例如过滤特殊字符
    return password;
  };

  // 密码验证规则
  const passwordRules = {
    validate: {
      required: (value: string) => {
        return (value && value.trim() !== '') || t('validation.required');
      },
      passwordFormat: (value: string) => {
        if (!value || value.trim() === '') {
          return true; // 已经被required验证处理
        }

        if (value.trim().length < 6 || value.trim().length > 25) {
          return t('validation.lengthInvalid');
        }

        return true;
      },
    },
  };

  return (
    <FormInput
      type={showPassword ? 'text' : 'password'}
      label={label !== undefined ? label : t('label')}
      name={name}
      control={control}
      placeholder={placeholder || ''}
      rules={passwordRules}
      clearable={clearable}
      formatInput={formatPassword}
      endIcon={
        <IconButton
          aria-label={t('toggleVisibility')}
          onClick={handleTogglePasswordVisibility}
          edge="end"
          sx={{ color: 'rgba(0, 0, 0, 0.54)', marginRight: '-8px' }}
        >
          {showPassword ? (
            <PwdShowOutlined className="text-[18px] lg:text-[20px] text-auxiliary-text" />
          ) : (
            <PwdHiddenOutlined className="text-[18px] lg:text-[20px] text-auxiliary-text" />
          )}
        </IconButton>
      }
      {...restProps}
      slotProps={{
        htmlInput: { maxLength: 25 },
        ...slotProps,
      }}
      layout={layout}
    />
  );
};

export default PasswordInput;
